import React from 'react'
import Header from '../Components/Header'
import { Link } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form'

import { FiMapPin} from "react-icons/fi";
import { FaChevronRight, FaSearch } from "react-icons/fa";
import HowItWorksImg from './../Images/how-it-works.png';
import Build1 from './../Images/build1.png';
import Build2 from './../Images/build2.png';
import Build3 from './../Images/build3.png';
import Build4 from './../Images/build4.png';
import Build5 from './../Images/build5.png';
import Build6 from './../Images/build6.png';

import {  IoTrendingUpSharp } from "react-icons/io5";
import { BiCheckShield } from "react-icons/bi";

import { FaHome, FaMapMarkerAlt, FaWallet, FaRegBuilding } from "react-icons/fa";
import Footer from '../Components/Footer';

const ResidentialPlots = () => {
    return (
        <>
            <Header />
            <div className="banner w-100 mb-90" style={{ backgroundImage: `url(${HowItWorksImg})` }}>
                <div className="container">
                    <div className="banner-title text-center">
                        <h1>Property List</h1>
                        <p><Link to="/">Home</Link> <span><FaChevronRight /></span> Property</p>
                    </div>


                </div>
            </div>
            {/* search bar starts */}

            <div className="home-search mb-70">

                <div className="container">
                    <div className="home-search-bx">
                        <div className="home-search-top">

                            <Tabs
                                defaultActiveKey="Sale"
                                variant='pills'
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                <Tab eventKey="Sale" title="Sale">
                                    <div className="home-search-inputs">
                                        <form action="">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Enter Location</label>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Select Your City</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>

                                                    </div>


                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Property Type</label>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Select Property Type</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>

                                                    </div>


                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Price Range</label>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Select Price Range</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>

                                                    </div>


                                                </div>
                                                <div className="col-md-3 my-auto text-center">

                                                    <div className="form-group">
                                                        <button type="submit" className="search-btn property-search"><FaSearch /> Submit</button>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </Tab>
                                <Tab eventKey="Rent" title="Rent">
                                    <div className="home-search-inputs">
                                        <form action="">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Enter Location</label>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Select Your City</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>

                                                    </div>


                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Property Type</label>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Select Property Type</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>

                                                    </div>


                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Price Range</label>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Select Price Range</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>

                                                    </div>


                                                </div>
                                                <div className="col-md-3 my-auto text-center">

                                                    <div className="form-group">
                                                        <button type="submit" className="search-btn property-search"><FaSearch /> Submit</button>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </Tab>
                                {/* <Tab eventKey="contact" title="Contact" disabled>
      Hi there 3
      </Tab> */}
                            </Tabs>
                            <span>





                            </span>
                        </div>

                    </div>
                </div>

            </div>
            {/* search bar ends */}

            {/* property list starts */}
           <div className="property-list mb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build1} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build2} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build3} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build4} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build5} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build1} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build6} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build3} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="prop-bx h-100">
                                <div className="prop-img">
                                    <img src={Build4} alt="" />
                                </div>
                                <div className="prop-text p-3">
                                <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location mb-3">
                                        <p><FiMapPin/> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-features d-flex justify-content-between mb-4">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                    <div className="hero-btns">
                <Link to="/property-details" className="common-btn me-4 w-100">View Opportunity</Link>
                
              </div>

                                    <div className="prop-btn">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* property list ends */}
            <Footer/>
        </>
    )
}

export default ResidentialPlots